import { render } from "./PricesSection.vue?vue&type=template&id=0912d5fc&ts=true"
import script from "./PricesSection.vue?vue&type=script&lang=ts"
export * from "./PricesSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__